"use client"

import { useState } from "react"
import AdminDashboardView from "./AdminDashboardView"
import SubAccountDashboardView from "./SubAccountDashboardView"
import styles from "./InventoryDashboardPage.module.css"

const InventoryDashboardPage = () => {

  const defaultAdmin = {
    id: 1,
    name: "Admin User",
    role: "Super User",
    type: "admin",
    active: true,
  }

  const storedAcc =
    JSON.parse(localStorage.getItem("inventory_active_account") || "null") ||
    defaultAdmin

  const [currentUser, setCurrentUser] = useState(storedAcc)

  const accounts = [
    defaultAdmin,
    { id: 2, name: "Renal Consultant", role: "Manager", type: "sub" },
    { id: 3, name: "Heart Care", role: "Manager", type: "sub" },
  ]

  const handleAccountSwitch = (account) => {
    setCurrentUser(account)
    localStorage.setItem("inventory_active_account", JSON.stringify(account))
  }

  const isAdmin = currentUser?.type === "admin"
  const DashboardView = isAdmin ? AdminDashboardView : SubAccountDashboardView

  return (
    <div className={styles.dashboard_container}>
      {}
      <div className={styles.dashboard_header}>
        <div className={styles.header_left}>
          <h1 className={styles.page_title}>Dashboard</h1>
          <p className={styles.page_subtitle}>
            Manage your inventory, track devices, and monitor warehouse
            operations
          </p>
        </div>
      </div>

      {}
      <DashboardView currentUser={currentUser} />
    </div>
  )
}

export default InventoryDashboardPage